import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import ClientsTable from "@/components/clients/clients-table";

const clientsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/clients/")({
  validateSearch: clientsSearchSchema,
  component: ClientsPage,
});

function ClientsPage() {
  const searchParams = Route.useSearch();

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <ClientsTable
        currentPage={searchParams.page}
        pageSize={10}
        basePath="/clients"
        searchParams={searchParams}
      />
    </div>
  );
}
